<div class="popover">
  <div class="popover-text" [innerHTML]="text">
  </div>
</div>
